import axios from '../axios'

const getTeacherEventsApi = async (id, startTime, endTime) => {
    return await axios.get(`api/admin/teachers/${id}/events`, { params: { startTime, endTime } })
}

export default getTeacherEventsApi
